import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from '../../services/auth';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = async () => {
    await signOut();
    navigate('/admin/login');
  };

  const navItems = [
    { path: '/admin', label: 'Dashboard', icon: FiIcons.FiHome },
    { path: '/admin/hero', label: 'Hero Section', icon: FiIcons.FiImage },
    { path: '/admin/about', label: 'About Jenny', icon: FiIcons.FiUser },
    { path: '/admin/resources', label: 'Resources', icon: FiIcons.FiBook },
    { path: '/admin/events', label: 'Events', icon: FiIcons.FiCalendar },
    { path: '/admin/leads', label: 'Leads & Analytics', icon: FiIcons.FiBarChart2 },
    { path: '/admin/settings', label: 'Settings', icon: FiIcons.FiSettings }
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className={`${sidebarOpen ? 'w-64' : 'w-20'} bg-gray-900 text-white transition-all duration-300 flex flex-col`}>
        <div className="p-4 border-b border-gray-800 flex items-center justify-between">
          {sidebarOpen && <span className="font-bold text-lg text-pink-500">Admin Panel</span>}
          <button onClick={() => setSidebarOpen(!sidebarOpen)} className="text-gray-400 hover:text-white">
            <SafeIcon icon={sidebarOpen ? FiIcons.FiChevronLeft : FiIcons.FiChevronRight} className="text-xl" />
          </button>
        </div>

        <nav className="flex-1 py-4">
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`flex items-center gap-3 px-4 py-3 hover:bg-gray-800 transition-colors ${
                location.pathname === item.path ? 'bg-pink-600 text-white' : 'text-gray-300'
              }`}
            >
              <SafeIcon icon={item.icon} className="text-xl flex-shrink-0" />
              {sidebarOpen && <span className="text-sm font-medium">{item.label}</span>}
            </Link>
          ))}
        </nav>

        <div className="p-4 border-t border-gray-800">
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-4 py-3 w-full hover:bg-gray-800 rounded-lg transition-colors text-gray-300"
          >
            <SafeIcon icon={FiIcons.FiLogOut} className="text-xl flex-shrink-0" />
            {sidebarOpen && <span className="text-sm font-medium">Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-auto">
        <div className="bg-white border-b border-gray-200 px-6 py-4 flex items-center justify-between">
          <h1 className="text-2xl font-bold text-gray-900">
            {navItems.find(item => item.path === location.pathname)?.label || 'Admin'}
          </h1>
          <Link to="/" className="text-pink-600 hover:text-pink-700 font-medium text-sm flex items-center gap-2">
            <SafeIcon icon={FiIcons.FiExternalLink} />
            View Site
          </Link>
        </div>
        
        <div className="p-6">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;